module.exports = __webpack_public_path__ + "static/chat-notification-d7241ff2f74b80d2073d78efe6f1326b.mp3";